import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ResetIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4.44932 7.10086L3.97983 4.7995C3.86944 4.25836 3.34127 3.90918 2.80013 4.01957C2.25899 4.12996 1.9098 4.65814 2.02019 5.19928L3.01962 10.0984C3.13002 10.6395 3.65819 10.9887 4.19933 10.8783L9.09842 9.87888C9.63956 9.76848 9.98875 9.24031 9.87836 8.69917C9.76796 8.15803 9.23979 7.80884 8.69865 7.91924L5.94759 8.48046C7.16135 6.39782 9.41838 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C9.06391 19 6.54767 17.192 5.50849 14.6248C5.30127 14.1129 4.71828 13.8658 4.20634 14.0731C3.69441 14.2803 3.44739 14.8633 3.65462 15.3752C4.98899 18.6717 8.22141 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C8.8352 3 6.05352 4.63335 4.44932 7.10086Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ResetIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ResetIcon);
